import { useMemo } from 'react';

import { useGetSubscriptionInfo, useGetUser, useStoreBrandings } from 'data-layer';
import { Add, BrandingIcon, OutvioRound } from 'icons';
import { FormattedMessage } from 'localization';

import { EnumDeskRoutes, EnumSettingRoutes } from '../../../constants';
import { SettingsSidebarMenuItem } from '../AdminSettingsSidebar';
import { adminRoles } from './deskSection';

const useBrandingSection = () => {
  const { data: subscriptionInfo } = useGetSubscriptionInfo();
  const { data: userData } = useGetUser();
  const isAdmin = adminRoles.some((role) => userData?.roles.includes(role));
  const { data: brandingListData, isFetching } = useStoreBrandings({
    enabled: subscriptionInfo?.subscription?.isActive && isAdmin,
  });

  const brandingSection: SettingsSidebarMenuItem = useMemo(
    () => ({
      icon: <BrandingIcon width={24} height={24} />,
      data: [
        ...(brandingListData?.map((item) => ({
          value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.branding}/${item._id}`,
          label: (
            <div>
              {
                // item?.customSenderNameOnShippingLabels
                //   ? item.customSenderNameOnShippingLabels
                //   :
                item.slug
              }
            </div>
          ),

          icon: (
            <img
              src={item.portalSettings?.favicon || item?.logo || OutvioRound}
              alt={item.slug}
              loading="lazy"
              width={24}
              height={24}
            />
          ),
        })) || []),
        {
          value: `/${EnumDeskRoutes.settings}/${EnumSettingRoutes.branding}/new`,
          label: (
            <div className="capitalize">
              <FormattedMessage id="settings.branding.add-brand.title" />
            </div>
          ),
          icon: <Add width={24} height={24} />,
        },
      ],
      translationKey: 'general.branding',
    }),
    [brandingListData],
  );

  return { brandingSection, isLoading: isFetching };
};

export { useBrandingSection };
